import moment from 'moment'
import { v4 as uuidv4 } from 'uuid'
const uppercaseFirstLetter = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
}

const formatInitialData = (data) => {
  return data.map((item) => ({
    ...item,
    isDone: false,
    completed: false,
    progress: 0,
  }))
}

const formatDate = (date: string | Date) => {
  return moment(date).format('DD-MM-YYYY')
}

const uuid = (): string => {
  return uuidv4()
}

const getLocaleCookie = () => {
  const cookie = document.cookie
  const lng =
    cookie.split(';').find((item) => item.includes('NEXT_LOCALE')) || ''
  return lng.split('=')[1] || 'vi'
}

const formatTime = (
  secs: number,
  type: 'sec' | 'min' = 'sec',
  showZero = true,
) => {
  if (!secs) return '00:00'
  const num = +secs
  const totalSeconds = +num.toFixed(0)
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60
  const preH = `${hours.toString().padStart(2, '0')}`
  const h = +preH > 0 || showZero ? `${preH || '00'}:` : ''
  const m = `${minutes.toString().padStart(2, '0')}`
  const s = `${seconds.toString().padStart(2, '0')}`
  if (type === 'sec') return `${h}${m}:${s}`
  if (type === 'min') return `${h}${m}`
}

const formatPomoTime = (val) => {
  return formatTime(val, 'sec', false)
}

const getNumber = (num: string | number) => {
  if (!num) return 0
  if (+num < 10) return `0${num}`
  return num
}

const showNotification = (
  title: string,
  body: string,
  icon: string = '/icon.png',
) => {
  if ('Notification' in window) {
    if (navigator.serviceWorker) {
      navigator.serviceWorker.getRegistration().then((registration) => {
        if (registration) {
          registration.showNotification(title, {
            body,
            icon,
          })
        }
      })
    } else if (Notification.permission === 'granted') {
      new Notification(title, {
        body,
        icon,
      })
    }
  }
}

const translateLanguages = [
  { label: 'English', value: 'en' },
  { label: 'Vietnamese', value: 'vi' },
  { label: 'Japanese', value: 'ja' },
  { label: 'Chinese', value: 'zh-CN' },
  { label: 'Korean', value: 'ko' },
]
const getLangByText = (lang: string) => {
  return translateLanguages.find((it) => it.label === lang)?.value || 'en'
}

export {
  formatDate,
  formatInitialData,
  formatPomoTime,
  formatTime,
  getLangByText,
  getLocaleCookie,
  getNumber,
  showNotification,
  uppercaseFirstLetter,
  uuid,
}
